import React, { useMemo, useState, useRef, useEffect } from "react";
import TextField from "@mui/material/TextField";
import { connect, getIn } from "formik";
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import Popper from "@mui/material/Popper";
import "../../../../pages/admin/admin.css";
import { Chip, Typography, Grid, Box, Button, IconButton, Divider, Tooltip } from "@mui/material";
import CustomizedCheckbox from "../CustomCheckBox";
import Avatar from '@mui/material/Avatar';
import { stringAvatar } from "../Avatar";


const CustomAutoCompleteBulkCampaign = connect(
    ({
        Datas,
        placeholder,
        formik,
        width,
        name,
        labelHeader,
        optionLabelName,
        optionId,
        mode,
        showAvatar,
        showCheckBox,
        showAvatarInChip,
        temporaryMode,
        multiple,
        onDeleteIcon,
        currentLabel,
        showBottomButton,
        buttonName,
        ...additionalProps
    }) => {

        const handleDeleteIcon = (event, currentLabel) => {
            onDeleteIcon(currentLabel);
        }

        const DropDownIcon = () => {
            return (
                <div style={{ display: 'flex', alignContent: 'center', backgroundColor: '#FFFFFF', borderRadius: '8px', marginTop: '-7px' }}>
                    <IconButton sx={{
                        marginRight: '5px', position: 'absolute !important', right: '0', pointerEvents: 'none !important'
                    }} flexGrow={1}>
                        <img
                            style={{ marginRight: '30px', paddingTop: '7px', paddingRight: '10px' }}
                            src={`${process.env.PUBLIC_URL}/icons/downArrowDropDown.svg`}
                            alt="edit"
                        >
                        </img>
                    </IconButton>
                    <Divider sx={{ color: '#99A0A8', height: '30px', marginTop: '4px', marginLeft: '20px' }} orientation="vertical" />
                    <img
                        style={{ padding: '7px' }}
                        src={`${process.env.PUBLIC_URL}/icons/deleteIconGrey.svg`}
                        alt="edit"
                        onClick={(e) => handleDeleteIcon(e, currentLabel)}
                    >
                    </img>
                </div>
            )
        };

        const PopperMy = useMemo(
            () => (props, option) => {
                return (
                    <Popper {...props} sx={{
                        paddingTop: "8px", paddingBottom: "8px", color: "#212121",
                        "& .MuiAutocomplete-listbox": {
                            "& li": {
                                height: (name === "dispositions" ? "75px !important" : "35px !important"),
                                padding: '0px',
                                paddingLeft: (option[optionLabelName] !== "Button") ? '5px' : '0px',
                                display: "flex",
                                alignItems: "center",
                                backgroundColor: "#FFFFFF !important",
                                marginLeft: "-1px",
                                maxWidth: "100% !important",
                                wordBreak: "break-all !important",
                                whiteSpace: "normal !important",
                                //list item specific styling
                            },
                            "& :hover": {
                                backgroundColor: "#FFFFFF !important"
                            },
                        },
                        '& .MuiAutocomplete-paper': {
                            boxShadow: 'none',
                            border: "1px solid #E5E5E5",
                            borderRadius: mode === "Edit" ? '0px' : "8px",
                            borderBottom: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                            borderRight: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                            borderLeft: mode === "Edit" ? '0px' : "1px solid #E5E5E5",
                            borderTop: mode === "Edit" ? "0px" : "1px solid #E5E5E5",
                            height: mode === "Edit" ? "290px" : "",
                        }, "& .MuiAutocomplete-noOptions": {
                            fontFamily: 'Roboto',
                            fontWeight: 400,
                            fontSize: "14px",
                            lineHeight: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#212121"
                        }
                    }} />
                );
            },
            [],
        );
        const selected = getIn(formik?.values, name)
        const [tempMode, setTempMode] = useState(temporaryMode ? temporaryMode : "temp")
        // const selectAll = selected?.length === Datas?.length;

        const [limit, setLimit] = useState(10);
        const listRef = useRef(null);

        // State for tracking search input value
        const [inputValue, setInputValue] = useState("");
        const [oldArray, setOldArray] = useState((selected?.length > 0) ? selected : []);
        let [selectAll, setSelectAll] = useState(selected?.length === Datas?.length);

        // Function to handle select all with event prevention
        const handleSelectAll = (e) => {
            // Make sure we stop event propagation
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            const filteredDatas = inputValue
                ? Datas.filter(item => item[optionLabelName].toLowerCase().includes(inputValue.toLowerCase()))
                : Datas;
            const newArray = makeNewArray(filteredDatas);
            setOldArray(newArray);

            if (selected.length === newArray.length) {
                // If all items are already selected, deselect them
                setOldArray([]);
                formik.setFieldValue(name, []);
                setSelectAll(false);
            } else {
                // Otherwise select all filtered items
                formik.setFieldValue(name, newArray);
                setSelectAll(true);
            }

            additionalProps.getValueFromAuto && additionalProps.getValueFromAuto(
                selected.length === newArray.length ? [] : newArray
            );
        };

        // Function to handle clear filtered items with event prevention
        const handleClearFiltered = (e) => {
            // Make sure we stop event propagation
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            // If no filter or no selected items, do nothing
            if (!selected || selected.length === 0) return;

            // Get the current filtered items that match the search text
            const filtered = Datas.filter(item =>
                item[optionLabelName].toLowerCase().includes(inputValue.toLowerCase())
            );

            // If no items match the filter, do nothing
            if (filtered.length === 0) return;

            // Create a set of IDs for faster lookup
            const filteredIds = new Set(filtered.map(item => item.id));

            // Remove matching items from selection (keep only non-filtered items)
            const newSelected = selected.filter(item => !filteredIds.has(item.id));

            // Update the form with the new selection
            formik.setFieldValue(name, newSelected);

            // Update other state as needed
            setSelectAll(false);
            setOldArray(newSelected);

            // Update external handlers
            additionalProps.getValueFromAuto && additionalProps.getValueFromAuto(newSelected);
        };

        const makeNewArray = (oldData) => {
            if (oldArray === null || oldArray.length < 1) {
                return oldData;
            } else {
                const newnew = oldArray.concat(oldData);
                const uniqueIds = [];
                const result = newnew.filter(obj => {
                    if (!uniqueIds.includes(obj.id)) {
                        uniqueIds.push(obj.id);
                        return true;
                    }
                    return false;
                })
                return result;
            }
        }

        function changeMode() {
            if (mode !== "Add") {
                setTempMode("Edit")
            }
        }

        const handleScroll = () => {
            const l = limit;
            setLimit(l + 5);
        }

        const handleClose = () => {
            setLimit(10);
        }

        const listItemStyle = useMemo(
            () => ({
                fontFamily: 'Roboto',
                fontWeight: 400,
                fontSize: "14px",
                lineHeight: "16px",
                color: '#212121',
                paddingLeft: "6px"
            }),
            []
        );

        let styleFieldHeader = useMemo(
            () => ({
                display: "flex",
                fontSize: "12px",
                fontWeigth: 400,
                color: '#212121',
                lineHeight: "20px",
                paddingLeft: "5px",
            }),
            []
        );

        // Update filtered data whenever the input value changes
        useEffect(() => {
            if (inputValue) {
                const filtered = Datas.filter(item =>
                    item[optionLabelName].toLowerCase().includes(inputValue.toLowerCase())
                );
                // Check if all filtered items are selected
                if (filtered.length > 0 && selected?.length > 0) {
                    const isAllSelected = filtered.every(item =>
                        selected.some(sel => sel.id === item.id)
                    );
                    setSelectAll(isAllSelected);
                }
            } else {
                setSelectAll(selected?.length === Datas?.length);
            }
        }, [inputValue, Datas, optionLabelName, selected]);

        return (
            <div>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                    {labelHeader && <Typography htmlFor={name}
                        fontSize='12px'
                        fontWeight={400}
                        lineHeight='14px'
                        marginBottom={'6px'}
                        marginLeft='1px'
                        color={'#212121'}
                    >
                        {labelHeader}
                    </Typography>}
                    <Box
                        sx={(mode === "Edit" && tempMode === "Edit") ? {
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            paddingTop: "8px",
                            paddingLeft: "15px",
                            paddingBottom: "8px",
                            borderBottomRightRadius: 0,
                            borderBottomLeftRadius: 0,
                        } : {}}
                    >
                        {mode === "Edit" && tempMode === "Edit" && <label
                            sx={mode === "Edit" && tempMode === "Edit" && {
                                color: "#212121",
                                fontWeight: 400,
                                fontSize: "14px",
                                marginLeft: "10px",
                            }}
                        >
                            {(selected?.length < 10) ? ("0" + (selected?.length > 0 ? selected?.length : "")) : selected?.length} Selected...
                        </label>
                        }
                    </Box>
                    <Box
                        sx={(mode === "Edit" && tempMode === "Edit") ? {
                            border: "1px solid #E5E5E5",
                            borderRadius: "8px",
                            paddingTop: "15px",
                            paddingLeft: "15px",
                            paddingBottom: "305px",
                            borderTop: 0,
                            paddingRight: "15px",
                            borderTopLeftRadius: 0,
                            borderTopRightRadius: 0,
                            height: mode === "Add" ? "30px" : "300px"
                        } : {}}
                    >
                        <Autocomplete
                            sx={{
                                '& 	.MuiAutocomplete-listbox': {
                                    scrollbarColor: 'rgb(190, 190, 190) rgb(240, 240, 240)',
                                    scrollbarWidth: 'thin',
                                },
                                "& .MuiAutocomplete - root": {
                                    "& .MuiAutocomplete-noOptions": {
                                        color: "red"
                                    }
                                },
                                "& .MuiAutocomplete-popupIndicatorOpen": { transform: "none", marginRight: "0px", padding: "0px", },
                            }}
                            popupIcon={additionalProps.popupIcon || <DropDownIcon />}
                            clearIcon={""}
                            noOptionsText={"No matching result found!"}
                            className="ozcw-scrollbar"
                            multiple={multiple}
                            size="small"
                            id={name}
                            options={Datas}
                            value={selected}
                            inputValue={inputValue}
                            selectOnFocus={false}
                            disableCloseOnSelect={true} // Always true to prevent dropdown from closing
                            renderTags={(value) => {
                                return (
                                    (mode === 'Add'
                                        ? selected.map(
                                            (selectedvalues, i) =>
                                            (selectedvalues[optionLabelName] !== "Select All" &&
                                                selectedvalues[optionLabelName] !== "Button" &&
                                                selectedvalues[optionLabelName] !== "ACTION_BUTTONS_ROW" &&
                                                <div key={i}>
                                                    < Chip
                                                        avatar={showAvatarInChip ? <Avatar
                                                            style={{ width: "24px", height: "24px", fontSize: "14px", color: "#212121", marginLeft: "4px" }}
                                                            {...stringAvatar(selectedvalues[optionLabelName])}>
                                                        </Avatar> : null}
                                                        key={selectedvalues[optionLabelName] + i} label={selectedvalues[optionLabelName]} size="small" sx={{
                                                            backgroundColor: "#F5F5F6", color: "#536580",
                                                            fontSize: "14px", fontWeight: 400, lineHeight: "16px",
                                                            marginTop: "4px", marginBottom: "4px", marginLeft: "4px", display: "flex", alignSelf: "center",
                                                            "& .MuiChip-label": {
                                                                color: '#536580',
                                                                textWrap: 'wrap',
                                                                wordBreak: 'break-all',
                                                                maxWidth: '230px'
                                                            }

                                                        }} />
                                                </div>
                                            )
                                        )
                                        :
                                        (<div style={{
                                            display: "flex",
                                            alignItems: 'center',
                                            alignContent: "center",
                                        }}>
                                            <Typography sx={styleFieldHeader}>
                                                {selected.filter(item => item[optionLabelName] !== "ACTION_BUTTONS_ROW").map(
                                                    (selectedvalues, index) =>
                                                        (index < 3 && ((selectedvalues[optionLabelName] + (((selected.length - 1) > index) ? ", " : ""))))
                                                )}
                                            </Typography>
                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                color: "#212121",
                                                paddingRight: '5px',
                                                paddingLeft: "5px"
                                            }}>
                                                {(selected.length > 3) ? "..." : ""}
                                            </Typography>

                                            <Typography sx={{
                                                fontSize: "14px",
                                                fontWeight: 400,
                                                color: "#99A0A8",

                                            }}>
                                                {(selected.length > 3) ? (("+" + (selected.length - 3))) : ""}
                                            </Typography>
                                        </div>))
                                )
                            }}

                            onChange={(e, value, reason, details) => {
                                // Skip the ACTION_BUTTONS_ROW from being selected
                                const filteredValue = value.filter(option => option[optionLabelName] !== "ACTION_BUTTONS_ROW");

                                if (multiple) {
                                    if (filteredValue.find((option) => option.id === 0)) {
                                        // Legacy Select All option (replaced by the buttons at the top)
                                        const filteredDatas = Datas.filter((value) => value[optionLabelName].includes(inputValue))
                                        const newArray = makeNewArray(filteredDatas);
                                        setOldArray(newArray);

                                        if (selected.length === newArray.length) {
                                            setOldArray([]);
                                            formik.setFieldValue(name, []);
                                            setSelectAll(false);
                                        }
                                        else {
                                            formik.setFieldValue(name, newArray);
                                            setSelectAll(true);
                                        }
                                    } else {
                                        formik.setFieldValue(name, filteredValue);
                                    }
                                } else {
                                    formik.setFieldValue(name, filteredValue);
                                }
                                additionalProps.getValueFromAuto && additionalProps.getValueFromAuto(filteredValue)
                            }}

                            getOptionLabel={
                                ((option) => option[optionLabelName])
                            }

                            ListboxProps={{
                                ref: listRef,
                                onScroll: handleScroll,
                            }}

                            onClose={handleClose}

                            PopperComponent={PopperMy}
                            renderOption={(props, option, { selected }) => {
                                // Render the action buttons row
                                if (option[optionLabelName] === "ACTION_BUTTONS_ROW") {
                                    return (
                                        <li {...props}
                                            style={{
                                                padding: 0,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                borderBottom: '1px solid #E5E5E5',
                                                height: 'auto !important'
                                            }}
                                            // These event handlers are critical to prevent the dropdown from closing
                                            onClick={(e) => e.stopPropagation()}
                                            onMouseDown={(e) => e.preventDefault()}
                                        >
                                            <Button
                                                sx={{
                                                    textTransform: 'none',
                                                    flex: 1,
                                                    justifyContent: 'center',
                                                    fontFamily: 'Roboto',
                                                    fontWeight: 400,
                                                    color: '#3D8BF8',
                                                    borderRight: '1px solid #E5E5E5',
                                                    minWidth: 'auto',
                                                    borderRadius: 0
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleSelectAll(e);
                                                    return false;
                                                }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            >
                                                Select All
                                            </Button>
                                            <Button
                                                style={{
                                                    textTransform: 'none',
                                                    flex: 1,
                                                    justifyContent: 'center',
                                                    fontFamily: 'Roboto',
                                                    fontWeight: 400,
                                                    color: '#3D8BF8',
                                                    minWidth: 'auto',
                                                    borderRadius: 0
                                                }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    handleClearFiltered(e);
                                                    return false;
                                                }}
                                                onMouseDown={(e) => e.preventDefault()}
                                            >
                                                {"Clear All"}
                                            </Button>
                                        </li>
                                    );
                                }

                                return (
                                    <Tooltip title={option[optionLabelName]}>
                                        <div style={{ bgcolor: "#FFFFFF", marginTop: option[optionLabelName] === "Button" && "10px", borderTop: option[optionLabelName] === "Button" && "1px solid #E5E5E5" }} >
                                            <li {...props} style={{ height: option[optionLabelName] === "Button" ? "32px" : "36px" }}>
                                                {(showCheckBox && (option[optionLabelName] !== "Button")) && <CustomizedCheckbox
                                                    checked={(option["id"] === 0) ? selectAll : selected}
                                                />}
                                                {(showAvatar && (option[optionLabelName] !== "Button")) && (option[optionLabelName] !== "Select All") &&
                                                    <Avatar style={{ width: "24px", height: "24px", fontSize: "14px", color: "#212121", marginLeft: "4px" }} {...stringAvatar(option[optionLabelName])}></Avatar>
                                                }
                                                {option[optionLabelName] === "Button" ?
                                                    <Button fullWidth sx={{
                                                        fontSize: "14px",
                                                        lineHeight: "16px"
                                                        , color: "#3D8BF8", fontWeight: '400', bgcolor: "transparent"
                                                    }} onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        additionalProps.bottomButtonFunction && additionalProps.bottomButtonFunction();
                                                    }}
                                                        onMouseDown={(e) => e.preventDefault()}
                                                    >
                                                        {buttonName}
                                                    </Button>
                                                    :
                                                    <Typography sx={listItemStyle} >{option[optionLabelName]}</Typography>
                                                }
                                            </li>
                                        </div>
                                    </Tooltip>
                                )
                            }}
                            style={{ width: { width } }}

                            onInputChange={(e, v, reason) => {
                                if (reason === 'input') {
                                    setInputValue(v);
                                }
                            }}

                            renderInput={(params) => (
                                <div style={{ display: 'flex', alignContent: 'center' }}>
                                    <TextField
                                        onClick={changeMode}
                                        sx={{
                                            minWidth: "326px",
                                            paddingRight: tempMode === "temp" ? "" : "10px",
                                            '& .MuiOutlinedInput-root': {
                                                minHeight: "30px",
                                                fontSize: "14px",
                                                color: params.inputProps.value === "" ? "#99A0A8" : "#212121",
                                                borderRadius: '8px',
                                            },
                                            '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                                                paddingTop: '0px',
                                                paddingBottom: '0px',
                                            },
                                            '& .MuiAutocomplete-input': {
                                                display: (tempMode === 'temp') && (mode !== 'Add') ? 'none' : 'block'
                                            },
                                            "& .MuiOutlinedInput-root.Mui-focused": {
                                                "& > fieldset": mode === "Add" ? {
                                                    borderBottomLeftRadius: "0px", borderBottomRightRadius: '0px', border: "1px solid #E5E5E5"
                                                } : { border: "1px solid #E5E5E5" },
                                            },
                                            "& .MuiOutlinedInput-root:hover": {
                                                "& > fieldset": {
                                                    border: "1px solid #E5E5E5"
                                                }
                                            }
                                        }}
                                        {...params} placeholder={(tempMode !== 'temp') || (mode === 'Add') ? placeholder : ""} />
                                </div>
                            )}
                            isOptionEqualToValue={(option, value) => option[optionId || optionLabelName] === value[optionId || optionLabelName]}
                            filterOptions={(options, params) => {
                                let filtered = createFilterOptions({
                                    matchFrom: 'any',
                                    limit: limit,
                                })(options, params);

                                let selectedFiltered = createFilterOptions({//for the selected list also to be filtered
                                    matchFrom: 'any',
                                    limit: limit,
                                })((selected || []), params);

                                let sortedOptions = filtered
                                let uniqueOptions = filtered

                                if (selected?.length > 0) {
                                    // sortedOptions = [...selected, ...filtered]
                                    sortedOptions = [...selectedFiltered, ...filtered]//for the selected list also to be filtered
                                    uniqueOptions = [...new Map(sortedOptions.map((item) => [item['id'], item])).values()];
                                }
                                filtered = uniqueOptions
                                let newOptions = filtered
                                setSelectAll(selected?.length === newOptions?.length);

                                // Add the buttons as special options at the top of the list
                                if (additionalProps.showselectall && filtered.length > 0) {
                                    newOptions.unshift({
                                        id: "actionButtons",
                                        [optionLabelName]: "ACTION_BUTTONS_ROW"
                                    });
                                }

                                if (filtered.length > 0) {
                                    if (showBottomButton) {
                                        newOptions.push({ id: Datas.length + 1, [optionLabelName]: "Button" })
                                    }
                                }

                                if (showBottomButton || additionalProps.showselectall) {
                                    return newOptions;
                                }
                                else {
                                    return filtered;
                                }
                            }}
                            {...additionalProps}
                        />
                    </Box>
                </Grid>

            </div >
        );
    }
);
export default CustomAutoCompleteBulkCampaign;